import { render } from "./SubscriberRejects.vue?vue&type=template&id=622fb0c0&scoped=true"
import script from "./SubscriberRejects.vue?vue&type=script&lang=js"
export * from "./SubscriberRejects.vue?vue&type=script&lang=js"

import "./SubscriberRejects.vue?vue&type=style&index=0&id=622fb0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622fb0c0"]])

export default __exports__